// import { SchemeTypes } from '../../../../config';
import { LanguagesEnum } from '../../../../config/languages';

const CONFIGURATION = {};

export const Translations = {
  header: {
    [LanguagesEnum.English]: 'Supplies from Fixed Establishments',
    [LanguagesEnum.Greek]: 'Supplies from Fixed Establishments',
  },
  add_supply: {
    [LanguagesEnum.English]: 'Add Supply',
    [LanguagesEnum.Greek]: 'Add Supply',
  },
};

export default CONFIGURATION;
